import ApplicationModel, { attr } from '../ApplicationModel';
import { type IntegrationAttributes } from './generated/IntegrationAttributes';
import { model } from '../modelBuilder';
import { titleize } from 'inflected';

interface Integration extends IntegrationAttributes {}

@model
class Integration extends ApplicationModel {
  // Start auto-generated
  static typename: 'Integration' = 'Integration';
  get typename(): 'Integration' {
    return 'Integration';
  }

  static internalTypename: 'Integration' = 'Integration';
  get internalTypename(): 'Integration' {
    return 'Integration';
  }

  static fields = {
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    serviceName: attr({ readable: true }),
    version: attr({ readable: true }),
  };
  // End auto-generated

  get title() {
    return this.name || titleize(this.serviceName);
  }
}

export default Integration;
